var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"tPfBIGJzmxQ576xatNbZd"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { getSentryInitOptions } from '~logic/sentry/getSentryInitOptions'
import { initSentry } from '~logic/sentry/initSentry'

const initOptions = getSentryInitOptions()

initSentry(initOptions)
